import { theme } from "../config/theme";

const Paths = {
  BASE: "/",
  TOKENS: "/tokens",
  APIKEYS: "/apikeys",
  USERS: "/users",
  ANALYTICS: "/analytics",
  DASHBOARD: "/dashboard",
  ORGANIZATIONS: "/organizations"
};

const ScreenSize = {
  XXS: 360,
  XS: 576,
  SM: 768,
  MD: 992,
  LG: 1200,
  XL: 1400
};

const MediaScreenWidth = {
  XXS: `${ScreenSize.XXS}px`,
  XS: `${ScreenSize.XS}px`,
  SM: `${ScreenSize.SM}px`,
  MD: `${ScreenSize.MD}px`,
  LG: `${ScreenSize.LG}px`,
  XL: `${ScreenSize.XL}px`
};

const NamePattern = "^[a-zA-Z0-9_$# ]*$";
const AlphabeticPattern = "[a-zA-Z]";
const NumeralPattern = "^[0-9]*$";

const TABS = {
  ANALYTICS: "Analytics",
  DASHBOARD: "Dashboard",
  ORGANIZATIONS: "Organizations",
  PROJECTS: "Projects",
  USERS: "Users"
};

const REQUEST_HEADERS = {
  AUTHORIZATION: "Authorization",
  ORGANIZATION_ID: "X-Suki-Organization-Id",
  REQUEST_ID: "X-Suki-Request-Id",
  TRACE_ID: "X-Suki-Trace-Id",
  USER_AGENT: "X-Suki-User-Agent",
  USER_ID: "X-Suki-User-Id"
};

const METRIC_TYPES = {
  CHECK_PASSED: "uptime_check/check_passed",
  REQUEST_LATENCY: "uptime_check/request_latency"
};

const COLORS = Object.values(theme.palette?.chart);

const DATE_FORMATS = {
  MMMDDYYYY: "MMM DD, YYYY",
  MMMDDYYYYHMM: "MMM DD, YYYY h:mm:ss A",
  HMMA: "h:mm a",
  YYYYMMDD: "YYYY-MM-DDTHH:mm:ss",
  MMMDDHH: "MMM DD, h:mm A"
};

export {
  AlphabeticPattern,
  COLORS,
  DATE_FORMATS,
  MediaScreenWidth,
  NamePattern,
  NumeralPattern,
  Paths,
  REQUEST_HEADERS,
  ScreenSize,
  TABS,
  METRIC_TYPES
};
